jQuery(document).ready(function ($) {

    $('.js-select').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        theme: 'pwc'
    });
});
